import { CheckboxGroup } from "common/styleguide/CheckboxGroup";
import { CTA } from "common/styleguide/CTA";
import { Popover } from "common/styleguide/Popover";
import { PopoverLinkMenu, PopoverLinkMenuHeading, PopoverLinkMenuItem } from "common/styleguide/PopoverLinkMenu";
import { PopoverMenu, PopoverMenuHeading, PopoverMenuItem } from "common/styleguide/PopoverMenu";
import { RadioGroup } from "common/styleguide/RadioGroup";
import { OrderedMap, Set } from "immutable";
import React, { useRef, useState } from "react";
import styles from "./Popovers.scss";
const noop = () => {};

const POSITIONS = ["top", "right", "bottom", "left"];

const overlays = OrderedMap({
  cake: "Cake",
  pie: "Pie",
  distanceMarkerOverlay: "Distance Markers",
});

const actions = OrderedMap({
  solveFerry: "Solve for Ferry",
  solvePeace: "Solve for World Peace",
});

export const Popovers = () => {
  const [position, setPostion] = useState(0);
  const target1 = useRef(null);
  const target2 = useRef(null);
  const target3 = useRef(null);
  const target4 = useRef(null);
  const container1 = useRef(null);
  const container2 = useRef(null);
  const container3 = useRef(null);
  const container4 = useRef(null);

  const changePosition = () => {
    setPostion((position + 1) % 4);
  };

  return (
    <div>
      <h1>Popovers</h1>
      <p>
        Popover with <code>insideMargin = true</code>
      </p>
      <div className={styles.demoContainer} ref={container1}>
        <CTA inline ref={target1} onClick={changePosition}>
          Click Me to Change Position
        </CTA>
        <Popover container={container1} target={target1} placement={POSITIONS[position]} onRequestClose={noop}>
          <h3>Popover</h3>
          <div>position: {POSITIONS[position]}</div>
        </Popover>
      </div>
      <p>
        Popover with <code>insideMargin = false</code>
      </p>
      <div className={styles.demoContainer} ref={container2}>
        <CTA ref={target2} inline onClick={changePosition}>
          Click Me to Change Position
        </CTA>
        <Popover
          container={container2}
          target={target2}
          insideMargin={false}
          placement={POSITIONS[position]}
          onRequestClose={noop}
        >
          <h3>Popover</h3>
          <div>position: {POSITIONS[position]}</div>
        </Popover>
      </div>
      <h2>PopoverMenu</h2>
      <PopoverMenu // problem: react-overlays is not allowing container overflow
        container={container4}
        target={target4}
        insideMargin={false}
        placement="bottom"
        onRequestClose={noop}
      >
        <PopoverMenuHeading>A menu heading</PopoverMenuHeading>
        <PopoverMenuItem>
          <RadioGroup style={{ margin: "0 0" }} horizontal options={overlays} selected="cake" />
        </PopoverMenuItem>
        <PopoverMenuHeading>Another menu heading</PopoverMenuHeading>
        <PopoverMenuItem>
          <CheckboxGroup style={{ margin: "0 0" }} horizontal options={actions} selected={Set(["solveFerry"])} />
        </PopoverMenuItem>
      </PopoverMenu>
      <p ref={container4}>
        <a ref={target4} style={{ display: "inline-block" }}>
          More Options
        </a>
      </p>
      <p>
        Martens liege-bastogne-liege res firma mitescere nescit rund um koln as the toto turns, as the toto turns
        cassette choley pays de loire cat among the pigeons cycles goff flanders. Nevele bianchi bruges randonneur
        schleck koppenberg, planckaert ronde van belgie boonen res firma mitescere nescit the. Cog echelon, meyrueis
        lanterne rouge commissaire with rouleur derby arriere du peloton.
      </p>
      <p>
        Martens liege-bastogne-liege res firma mitescere nescit rund um koln as the toto turns, as the toto turns
        cassette choley pays de loire cat among the pigeons cycles goff flanders. Nevele bianchi bruges randonneur
        schleck koppenberg, planckaert ronde van belgie boonen res firma mitescere nescit the. Cog echelon, meyrueis
        lanterne rouge commissaire with rouleur derby arriere du peloton.
      </p>
      <h2>PopoverLinkMenu</h2>
      <p ref={container3}>
        <a ref={target3} style={{ display: "inline-block" }}>
          More Options
        </a>
      </p>
      <PopoverLinkMenu // problem: react-overlays is not allowing container overflow
        container={container3}
        target={target3}
        insideMargin={false}
        placement="bottom"
        onRequestClose={noop}
      >
        <PopoverLinkMenuHeading>A menu heading</PopoverLinkMenuHeading>
        <PopoverLinkMenuItem>Export GPX file</PopoverLinkMenuItem>
        <PopoverLinkMenuItem>Re-fetch Elevations</PopoverLinkMenuItem>
        <PopoverLinkMenuHeading>Another menu heading</PopoverLinkMenuHeading>
        <PopoverLinkMenuItem>Solve for Ferry</PopoverLinkMenuItem>
        <PopoverLinkMenuItem>Render a Big One</PopoverLinkMenuItem>
        <PopoverLinkMenuItem>Call Roberto Rigoli</PopoverLinkMenuItem>
      </PopoverLinkMenu>
      <p>
        Martens liege-bastogne-liege res firma mitescere nescit rund um koln as the toto turns, as the toto turns
        cassette choley pays de loire cat among the pigeons cycles goff flanders. Nevele bianchi bruges randonneur
        schleck koppenberg, planckaert ronde van belgie boonen res firma mitescere nescit the. Cog echelon, meyrueis
        lanterne rouge commissaire with rouleur derby arriere du peloton.
      </p>
      <p>
        Martens liege-bastogne-liege res firma mitescere nescit rund um koln as the toto turns, as the toto turns
        cassette choley pays de loire cat among the pigeons cycles goff flanders. Nevele bianchi bruges randonneur
        schleck koppenberg, planckaert ronde van belgie boonen res firma mitescere nescit the. Cog echelon, meyrueis
        lanterne rouge commissaire with rouleur derby arriere du peloton.
      </p>
    </div>
  );
};
